import { patchState, signalStoreFeature, withHooks, withMethods, withState } from '@ngrx/signals';

type FilterStr = {
    sorting: { active: string; direction: 'asc' | 'desc' | '' };
}

const initialState: FilterStr = {
    sorting: { active: '', direction: '' },
};

export function withSorting() {
    return signalStoreFeature(
        withState(initialState),
        withMethods((store) => ({
            setSorting(active: string, direction: 'asc' | 'desc' | '') {
                patchState(store, { sorting: { active, direction } });
            },

        })),
    );
}